export const normalizeDate = (date) => {
    const dateInstance = new Date(date);
    return new Date(dateInstance.getUTCFullYear(), dateInstance.getUTCMonth(), dateInstance.getUTCDate());
};
export const getCurrentTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
